import { IApiEntity } from 'entities/entity';

export type UnsubscribeTypes = 'GlobalUnsubscribe' | 'UnsubscribeURL' | 'UnsubscribeTemplate';

export type EmailTrackingUnsubscribeTypes = 'GlobalUnsubscribeEmailTracking' | 'UnsubscribeEmailTrackingTemplate';

export const UNSUBSCRIBE_ITEMS: IApiEntity[] = [
  { id: 'GlobalUnsubscribe', name: 'client.unsubscribeConstants.globalUnsubscribe' },
  { id: 'UnsubscribeTemplate', name: 'client.unsubscribeConstants.unsubscribeTemplate' },
  { id: 'UnsubscribeURL', name: 'client.unsubscribeConstants.urlRedirect' },
];

export const EMAIL_TRACKING_UNSUBSCRIBE_ITEMS: IApiEntity[] = [
  {
    id: 'GlobalUnsubscribeEmailTracking',
    name: 'client.emailTrackingUnsubscribeConstants.globalUnsubscribeEmailTracking',
  },
  {
    id: 'UnsubscribeEmailTrackingTemplate',
    name: 'client.emailTrackingUnsubscribeConstants.unsubscribeEmailTrackingTemplate',
  },
];
